import React, {useState, forwardRef} from 'react';
import {connect} from 'react-redux';
import {NavLink as RouterLink, useHistory} from 'react-router-dom';
import clsx from 'clsx';
//MUI
import {makeStyles} from 'tss-react/mui';
import {useTheme} from '@mui/material/styles';
import {Box, useMediaQuery} from '@mui/material';
import Divider from '@mui/material/Divider';
import Badge from '@mui/material/Badge';
import Hidden from '@mui/material/Hidden';
//ICONS
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/NotificationsOutlined';
//DS
import {Topbar, MenuModulos, Copyright, SidebarMenu, hooks} from 'lib.front';
import {PerfilMenu} from './components';
import {useLogOut} from 'src/hooks';
import {modulos} from 'src/config';
import {baseName} from 'src/config/keys';
const logoUri = `${baseName}/images/logos/logo_dscont_whiteH50.png`;
const useStyles = makeStyles()(theme => {
   return {
      active: {
         color: theme.palette.primary.main,
         fontWeight: theme.typography.fontWeightMedium,
         '& $icon': {
            color: theme.palette.primary.main
         }
      },
      root: {
         paddingTop: '56px',
         height: '100%',
         [theme.breakpoints.up('sm')]: {
            paddingTop: '64px'
         }
      },
      shiftContent: {
         paddingLeft: '250px'
      },
      closeIsDesktop: {
         paddingLeft: '80px'
      },
      content: {
         height: '100%',
         paddingTop: theme.spacing(10)
      },
      divider: {
         my: theme.spacing(2, 0)
      },
      flexGrow: {
         flexGrow: 1
      },
      signOutButton: {
         marginLeft: theme.spacing(1)
      },
      buscador: {
         border: '1px solid #e2e2e1',
         overflow: 'hidden',
         borderRadius: 4,
         backgroundColor: theme.palette.primary.light
      }
   };
});

const CustomRouterLink = forwardRef((props, ref) => {
   const {classes} = useStyles();
   const {itemprops, to, ...others} = props;
   if (to || (itemprops && itemprops.to)) {
      const refLink = to || itemprops.to;
      return (
         <div ref={ref} style={{flexGrow: 1}}>
            <RouterLink activeClassName={classes.active} {...others} to={refLink} />
         </div>
      );
   } else {
      return <button {...props} />;
   }
});

function Main({children, usuario}) {
   const history = useHistory();
   const {classes,cx} = useStyles();
   const theme = useTheme();
   const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
      defaultMatches: true
   });
   // CONTROL DE VISIBILIDAD DEL MENU
   const {
      openSidebar,
      toggleSideBarOpen,
      handleSidebarOpen,
      handleSidebarClose
   } = hooks.useOpenSidebar(isDesktop);

   //TOPBAR
   const logOut = useLogOut();
   const [notifications] = useState([]);

   const [encontrado, setEncontrado] = useState({value: null, input: ''});
   function handleEncontradoInput(e, newValue) {
      setEncontrado({...encontrado, input: newValue});
   }
   function handleEncontradoValue(e, newValue) {
      if (newValue && newValue.to) {
         history.push(newValue.to);
         setEncontrado({value: null, input: ''});
      }
   }
   function handleItemOnClick(item) {
      if (item.to) {
         history.push(item.to);
      }
   }
   return (
      <Box>
         <Topbar>
            <IconButton color="inherit" onClick={toggleSideBarOpen} size="large">
               <MenuIcon />
            </IconButton>
            <RouterLink to="/">
               <img alt="Logo" src={logoUri} />
            </RouterLink>
            {/* BUSCADOR */}
            <Box className={classes.flexGrow}>
               {/*
               <Autocomplete
                  options={modulos}
                  getOptionLabel={option => {
                     return option.text;
                  }}
                  renderInput={params => {
                     let {InputProps: ImputPropsCustom, ...otherParams} = params;
                     ImputPropsCustom = {
                        ...ImputPropsCustom,
                        startAdornment: (
                           <InputAdornment position="start">
                              <SearchIcon />
                           </InputAdornment>
                        )
                     };
                     return (
                        <TextField
                           sx={styles.buscador}
                           InputProps={ImputPropsCustom}
                           variant="outlined"
                           margin="dense"
                           {...otherParams}
                        />
                     );
                  }}
               />
               */}
            </Box>
            {/* BOTONES BARRA SUPERIOR */}
            <Box sx={{display: {lg: 'none', xl: 'block'}}}>
               <IconButton color="inherit" size="large">
                  <Badge badgeContent={notifications.length} color="primary" variant="dot">
                     <NotificationsIcon />
                  </Badge>
               </IconButton>
            </Box>
            <PerfilMenu
               usuario={usuario}
               mapaUsuario={{
                  avatarSrc: 'avatar',
                  nombre: 'nombre',
                  apellido: 'apPaterno',
                  titulo: 'especialidad'
               }}
               logOut={logOut}
            />
         </Topbar>
         <SidebarMenu
            onMouseEnter={handleSidebarOpen}
            onMouseLeave={handleSidebarClose}
            onClose={handleSidebarClose}
            open={openSidebar}
            variant={isDesktop ? 'permanent' : 'temporary'}
            anchor="left"
         >
            <MenuModulos
               dividerProps={{sx: {}}}
               modulos={modulos}
               mapaModulo={{
                  titulo: 'title',
                  icono: 'icon',
                  nodos: 'submenu',
                  valorIgnorar: 'to'
               }}
               buscadorProps={{
                  valorIgnorar: '/notFound',
                  soloHojas: true,
                  value: encontrado.value,
                  onChange: handleEncontradoValue,
                  inputValue: encontrado.input,
                  onInputChange: handleEncontradoInput,
                  clearOnBlur: true,
                  clearOnEscape: true,
                  selectOnFocus: true,
                  variant: 'standard'
               }}
               listaMultiNivelProps={{
                  contraerTodos: !openSidebar,
                  itemComponent: CustomRouterLink,
                  onItemClick: handleItemOnClick,
                  sx: {}
               }}
               incluirBuscador={openSidebar}
               style={{marginTop: '16px'}}
            />

            <Divider />
         </SidebarMenu>
         <Box
            component="main"
            className={cx(
               classes.content,
               isDesktop && openSidebar && classes.shiftContent,
               isDesktop && !openSidebar && classes.closeIsDesktop
            )}
         >
            {children}
            <Copyright entidad="Data Service" urlEntidad="https://www.dscont.pe/" />
         </Box>
      </Box>
   );
}

function mapStateToProps(state) {
   return {
      usuario: state.auth.usuario
   };
}
function mapDispatchToProps() {
   return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);
